module.exports = __webpack_public_path__ + "media/svg/medio-blocked-21879860.svg";